import { useState } from "react"
import { Flex, Space } from "antd"
import { Trans, useTranslation } from "react-i18next"
import { CheckCircleOutlined } from "@ant-design/icons"
import { Text } from "../Text"
import { TRANSLATOR_URL } from "../../constants"
import { Tooltip } from "../Tooltip"

type UploadProps = {
  message: string
  url?: string
  articleName?: string
}

type CopyProps = UploadProps & {
  czUrl?: string
  czArticleName?: string
  isTextWrong?: boolean
}

type UploadImageProps = {
  message: string
  imageName?: string
}

type ClearCacheProps = {
  message: string
  portalName?: string
}

export const UploadText: React.FC<UploadProps> = ({
  message,
  url,
  articleName,
}) => {
  const [clicked, setClicked] = useState(false)
  const { t } = useTranslation()
  const clickHandler = () => setClicked(true)

  return (
    <Space>
      <Text>
        <Trans
          i18nKey={`uploading.process.${message}`}
          values={{ articleName }}
          components={{ i: <i /> }}
        />
      </Text>
      {url && (
        <Text
          type="link"
          href={url}
          target="_blank"
          onClick={clickHandler}
          onAuxClick={clickHandler}
        >
          {articleName}
        </Text>
      )}
      {clicked && (
        <Tooltip text={t("tooltips.clicked")}>
          <CheckCircleOutlined />
        </Tooltip>
      )}
    </Space>
  )
}

export const CopyText: React.FC<CopyProps> = ({
  message,
  url,
  articleName,
  czUrl,
  czArticleName,
  isTextWrong,
}) => {
  const [clicked, setClicked] = useState(false)
  const { t } = useTranslation()
  const clickHandler = () => setClicked(true)

  return (
    <>
      <Flex justify="space-between">
        <Space>
          <Text>
            <Trans
              i18nKey={`copying.process.${message}`}
              values={
                czArticleName ? { articleName: czArticleName } : { articleName }
              }
              components={{ i: <i /> }}
            />
          </Text>
          {czUrl && (
            <Text
              type="link"
              href={czUrl}
              target="_blank"
              onClick={clickHandler}
              onAuxClick={clickHandler}
            >
              {czArticleName}
            </Text>
          )}
          {clicked && (
            <Tooltip text={t("tooltips.clicked")}>
              <CheckCircleOutlined />
            </Tooltip>
          )}
        </Space>
        {url && (
          <Text type="link" href={url} target="_blank">
            <Trans i18nKey="copying.process.originalArticleLink" />
          </Text>
        )}
      </Flex>
      {isTextWrong && (
        <Space>
          <Text type="warning">
            <Trans
              i18nKey="copying.process.notTranslated"
              values={{ czArticleName }}
              components={{ i: <i /> }}
            />
          </Text>
          <Text type="link" href={TRANSLATOR_URL} target="_blank">
            <Trans i18nKey="copying.process.translator" />
          </Text>
        </Space>
      )}
    </>
  )
}

export const UploadImageText: React.FC<UploadImageProps> = ({
  message,
  imageName,
}) => (
  <Space>
    <Text>
      <Trans
        i18nKey={`uploadingImage.process.${message}`}
        values={{ imageName }}
        components={{ i: <i /> }}
      />
    </Text>
  </Space>
)

export const ClearCacheText: React.FC<ClearCacheProps> = ({
  message,
  portalName,
}) => (
  <Space>
    <Text>
      <Trans
        i18nKey={`cacheClearing.process.${message}`}
        values={{ portalName }}
        components={{ i: <i /> }}
      />
    </Text>
  </Space>
)
